export default __webpack_public_path__ + "static/media/Westermarck Javelin.a010008d.jpg";